export const IS_LOCALHOST = window.location.origin.includes('localhost');
export const IS_DEVELOPMENT = process.env.REACT_APP_ENV === 'development';
export const IS_DEMO = process.env.REACT_APP_ENV === 'demo';
export const IS_DDA_MODE = process.env.REACT_APP_BUILD_MODE === 'dda';

export type ENVIRONMENTS = 'development' | 'demo' | 'stage' | 'production';

export const COUNTRIES_LIST = ['CAR', 'NG', 'SN'] as const;

export type COUNTRIES = typeof COUNTRIES_LIST[number];
const COUNTRY_MAP: Record<COUNTRIES, {short: string}> = {
    CAR: {short: 'CF'},
    NG: {short: 'NG'},
    SN: {short: 'SN'},
};
export const COUNTRY = process.env.REACT_APP_COUNTRY as COUNTRIES;
export const COUNTRY_NAMING = COUNTRY_MAP[COUNTRY];

export const IS_SN = process.env.REACT_APP_COUNTRY === 'SN';
export const IS_NG = process.env.REACT_APP_COUNTRY === 'NG';
export const IS_CAR = process.env.REACT_APP_COUNTRY === 'CAR';
